import { render } from "./UploadCSV.vue?vue&type=template&id=12a054c8"
import script from "./UploadCSV.vue?vue&type=script&lang=js"
export * from "./UploadCSV.vue?vue&type=script&lang=js"

import "./UploadCSV.vue?vue&type=style&index=0&id=12a054c8&lang=scss"

import exportComponent from "C:\\Users\\caleb\\OneDrive\\Desktop\\apps\\kff_ordering_portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__